<template>
  <div class="swiper-container home aiSound">
    <div class="home-head">
      <TopHeader></TopHeader>
    </div>
    <swiper href="mySwiper" class="home-content swiper-no-swiping" :options="swiperOption" ref="mySwiper">
      <swiper-slide class="swiper-item">
        <AiSlide1 @swiperClick="swiperClick" />
      </swiper-slide>
      <swiper-slide class="swiper-item">
        <AiSlide2/>
      </swiper-slide>
      <swiper-slide class="swiper-item">
        <AiSlide3/>
      </swiper-slide>
      <swiper-slide class="swiper-item" >
        <AiSlide4/>
      </swiper-slide>
      <swiper-slide class="swiper-item footer-item">
        <Footer class="special-foot"></Footer>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>
<style>
.new_foot {
  background-color: #4d4d4d;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.aiSound .swiper-container-autoheight .swiper-slide:nth-child(5) {
  height: 164px;
  background-color: #4d4d4d;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.letterSpacing {
  letter-spacing: 4px;
}
.home-need-center {
  margin-bottom: calc(var(--bili) * 170);
}
.left-selection a {
  color: white;
}
.special-foot {
  min-height: 164px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.left-selection a:hover {
  color: #e36423 !important;
}
/* .home-head .ivu-dropdown-item {
  font-size: calc(var(--bili) * 14) !important;
} */
.home .swiper-container-autoheight,
.home .swiper-container-autoheight .swiper-slide {
  height: 100%;
}
/* .home .swiper-container-autoheight .swiper-slide {
  height: 100% !important;
} */
.home .swiper-wrapper {
  height: 100% !important;
}
.home .productSet .swiper-container,
#app {
  width: 100%;
  height: 100%;
}
</style>
<style lang="scss">
.home {
  @include fullSize;
  .home-head {
    width: 100%;
    z-index: 9;
    position: fixed;
    left: 0;
    height: 71px;
    background: $bgColor;
    transition: background 1.5s ease-out;
  }
  .home-content {
    padding-top: 71px;
  }
  .special-set > div > div:last-child {
    height: auto !important;
  }
}
</style>

<script>
import TopHeader from "../../../common/compoments/TopHeader";
import AiSlide1 from "../components/AiSlide1.vue";
import AiSlide2 from "../components/AiSlide2.vue";
import AiSlide3 from "../components/AiSlide3.vue";
import AiSlide4 from "../components/AiSlide4.vue";
import AiSlide5 from "../components/AiSlide5.vue";
import Footer from "../components/Footer.vue";

export default {
  name: "home",
  components: {
    TopHeader,
    AiSlide1,
    AiSlide2,
    AiSlide3,
    AiSlide4,
    AiSlide5,
    Footer
  },
  data() {
    return {
      msg: "dataall",
      b1: "lmcTest1",
      b2: "lmcTest2",
      b3: "lmcTest3",
      showFooter: false,
      mySwiper:null,
      swiperOption: {
        initialSlide: 0,
        direction: "vertical",
        slidesPerView: "auto",
        autoHeight: true,
        mousewheel: true,
        setWrapperSize: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          bulletClass: "my-bullet",
          bulletActiveClass: "my-bullet-active"
        },
        // direction: "vertical",
        // slidesPerView: 1,
        // autoHeight: true,
        // mousewheel: true,
        // setWrapperSize: true,
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true,
        //   bulletClass: "my-bullet",
        //   bulletActiveClass: "my-bullet-active"
        //console.log(this.realIndex);
        // },
        on: {
          // 用于页头渐变颜色slideChangeTransitionStart:()=>{
          slideChangeTransitionStart: function() {
            var ele = document.getElementsByClassName("home-head")[0];
            var eleFont = document.getElementsByClassName("head-selection")[0];
            var eleLogo = document.getElementsByClassName("logo")[0];
            // var loginR = document.getElementsByClassName("right-selection")[0]
            // console.log(document.getElementsByClassName((".right-selection")))
            //.getElementsByTagName("div");
            if (this.realIndex == 0) {
              ele.style.background = "#060621";
              eleFont.style.color = "white";
              eleFont.getElementsByTagName("a")[0].style.color = "white";
              eleFont
                .getElementsByClassName("ivu-dropdown-rel")[0]
                .getElementsByTagName("a")[0].style.color = "white";
              eleLogo.className = "logo";
              // loginR[0].className = "new_login new_login_bcon1";
              // loginR[1].className = "new_login new_login_bcon2";
            } else {
              ele.style.background = "white";
              eleFont.style.color = "black";

              eleFont.getElementsByTagName("a")[0].style.color = "black";
              eleFont
                .getElementsByClassName("ivu-dropdown-rel")[0]
                .getElementsByTagName("a")[0].style.color = "black";
              eleLogo.className += " toggleLogo";

              // loginR[0].className = "new_login new_login_bcon3";
              // loginR[1].className = "new_login new_login_bcon4";
            }

            // console.log(this);

            // let swiper = this.$refs.mySwiper.swiper;
            // console.log(swiper);
          }
        }
      }
    };
  },
  created: function() {},
  mounted: function() {
    var that = this;
  },
  methods: {
    swiperClick(index){
      this.$refs.mySwiper.swiper.slideTo(index, 1000, true)
    }
  }
};
</script>
